import React, { useState, useEffect, useRef } from 'react';
import api from '../services/api';

function AuditPopover({ endpoint }) {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen]       = useState(false);
  const [error, setError]     = useState(null);
  const [pos, setPos]         = useState({ top: 0, left: 0 });
  const btnRef = useRef(null);
  const popRef = useRef(null);

  const fmt = (d) => {
    if (!d) return '-';
    const dt = new Date(d);
    return dt.toLocaleDateString('tr-TR') + ' ' + dt.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
  };

  const handleClick = async (e) => {
    e.stopPropagation();
    if (open) { setOpen(false); return; }
    // Pozisyon hesapla — fixed positioning ile parent overflow'larını aşar
    if (btnRef.current) {
      const rect = btnRef.current.getBoundingClientRect();
      // Popover'ı butonun altına ve sağına hizala; ekran sağına taşmasın
      const popWidth = 260;
      const left = Math.min(rect.right - popWidth, window.innerWidth - popWidth - 8);
      setPos({ top: rect.bottom + 4, left: Math.max(8, left) });
    }
    setOpen(true);
    if (data) return;
    setLoading(true); setError(null);
    try {
      const res = await api.get(endpoint);
      if (res.data?.success) {
        setData(res.data.data);
      } else {
        setError(res.data?.message || 'Veri yok');
      }
    } catch (e) {
      console.error('AuditPopover fetch:', endpoint, e);
      setError(e.response?.data?.message || e.message || 'İstek başarısız');
    } finally { setLoading(false); }
  };

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (btnRef.current?.contains(e.target)) return;
      if (popRef.current?.contains(e.target)) return;
      setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  return (
    <>
      <button
        ref={btnRef}
        onClick={handleClick}
        title="Kayıt Bilgisi"
        style={{
          background: 'none', border: '1px solid var(--border-secondary)',
          borderRadius: '50%', width: 22, height: 22, cursor: 'pointer',
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          color: 'var(--text-tertiary)', fontSize: '0.7rem', fontWeight: 700,
          transition: 'all 0.12s', flexShrink: 0,
        }}
        onMouseEnter={e => { e.currentTarget.style.background = 'var(--accent-glow)'; e.currentTarget.style.color = 'var(--accent-primary)'; e.currentTarget.style.borderColor = 'var(--accent-primary)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'none'; e.currentTarget.style.color = 'var(--text-tertiary)'; e.currentTarget.style.borderColor = 'var(--border-secondary)'; }}
      >i</button>

      {open && (
        <div ref={popRef} style={{
          position: 'fixed',                            // tablo overflow'unu aşar
          top: pos.top, left: pos.left, zIndex: 99999,
          background: 'var(--bg-card)', border: '1px solid var(--border-secondary)',
          borderRadius: 8, padding: '10px 14px', minWidth: 240,
          boxShadow: '0 8px 24px rgba(0,0,0,0.18)', fontSize: '0.78rem',
        }}>
          {loading ? (
            <span style={{ color: 'var(--text-tertiary)' }}>Yükleniyor...</span>
          ) : error ? (
            <div style={{ color: 'var(--danger)', whiteSpace: 'normal' }}>
              <strong>Bilgi alınamadı</strong>
              <div style={{ fontSize: 11, color: 'var(--text-tertiary)', marginTop: 4 }}>{error}</div>
            </div>
          ) : data ? (
            <table style={{ borderCollapse: 'collapse', width: '100%' }}>
              <tbody>
                {[
                  ['Oluşturulma', fmt(data.created_at)],
                  ['Oluşturan',   data.created_by_name || '-'],
                  ['Güncelleme',  fmt(data.updated_at)],
                  ['Güncelleyen', data.updated_by_name || '-'],
                ].map(([lbl, val]) => (
                  <tr key={lbl}>
                    <td style={{ color: 'var(--text-tertiary)', paddingRight: 10, paddingBottom: 4, fontWeight: 600, whiteSpace: 'nowrap' }}>{lbl}</td>
                    <td style={{ color: 'var(--text-primary)', paddingBottom: 4 }}>{val}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <span style={{ color: 'var(--danger)' }}>Bilgi yok</span>
          )}
        </div>
      )}
    </>
  );
}

export default AuditPopover;
